var helpForm = function () {
    let theForm = $("[data-id='helpform-content']");

    $('.m-form-optional').hide();
    $('.m-form-optional-improve').hide();

    $('.m-form-option-label input[type=radio]').on('click', function (evt) {
        let container = $(this).parent().parent().parent();
        let nextItem = $(this).parent().next('.m-form-optional');

        $('.m-form-optional', container).hide('300');
        $('.m-form-optional-improve').hide('300');

        if (nextItem.length)
            nextItem.show('400');
    });

    // If on a postback then re-click the selected radio to ensure its related form elements are shown
    $('.m-form-option-label input[type=radio]:checked').trigger('click');

    $('#NoReason').on('change', function (evt) {
        let textBoxLabel = $(this).find(':selected').attr('data-id');
        $('#HowElseCanWeImproveLabel').html(textBoxLabel);
        let nextItem = $('.m-form-optional-improve');
        if (nextItem.length)
            nextItem.show('400');
    });

    $("[data-id='helpform-cancel-button']").on('click', function (evt) {
        theForm
            .hide(400)
            .removeClass('open')
            .attr({
                'aria-expanded': 'false',
                'aria-selected': 'false',
                'aria-hidden': 'true'
            });
        resetForm();
    });

    // Form submission
    $("[data-id='helpform-submit-button']").on('click', function (e) {
        e.preventDefault();

        if ($('.m-form-option-label input[type=radio]:checked').length === 0) {
            return;
        }

        let alert = $("[data-id='helpform-alert']");
        let alertMessage = $("[data-id='helpform-alert-message']");

        // If button has class 'recaptchaButton' (added if Recaptcha turned on for Was this helpful form in Sitecore), use Recaptcha, otherwise submit directly.
        if ($(this).hasClass("recaptchaButton")) {
            // Use Recaptcha
            validateRecaptcha(submitHelpForm, recaptchaFailure);
        } else {
            // Skip Recaptcha and submit form directly
            submitHelpForm();
        }

        // Shared success logic
        function submitHelpForm() {

            let submitUrl = $('[data-id="helpform-submit-url"]', theForm).val();
            let contextId = $('[data-id="helpform-context-id"]', theForm);
            let contextUrl = $('[data-id="helpform-context-url"]', theForm);
            let contextName = $('[data-id="helpform-context-name"]', theForm);
            let emailGroupId = $('[data-id="helpform-group-id"]', theForm);
            let answer = $("input[name='WasThisInformationHelpful']:checked", theForm);
            let noReason = $('#NoReason', theForm);
            let howElseCanWeImprove = $('#HowElseCanWeImprove', theForm);
            let userEmail = $('#UserEmail', theForm);
            let phoneNumber = $('#PhoneNumber', theForm);

            let postData = {
                fhController: $("input[type='hidden'][name='fhController']", theForm).val(),
                fhAction: $("input[type='hidden'][name='fhAction']", theForm).val(),
                answer: answer.val(),
                noReason: noReason.val(),
                howCanWeImprove: howElseCanWeImprove.val(),
                contextId: contextId.val(),
                contextUrl: contextUrl.val(),
                contextName: contextName.val(),
                groupId: emailGroupId.val(),
                userEmail: userEmail.val(),
                phoneNumber: phoneNumber.val()
            };

            $.ajax({
                type: "POST",
                url: submitUrl,
                data: postData,
                success: function (data) {
                    if (data.Success) {
                        $('div.form-input-block').hide();
                        resetForm();
                        alertMessage.append(
                            '<p>Thank you for your feedback. Your feedback helps us improve the website.</p>' +
                            '<p>If you’d like to help us more, you can <a href="https://www.islington.gov.uk/join-our-website-testing-group">join our website testing group</a>.</p>'
                        );
                        alert.removeClass('m-form-error').addClass('m-alert m-alert-success');
                        alertMessage.removeClass("field-validation-error");
                    } else {
                        $('div.form-input-block').hide();
                        alertMessage.text(data.ErrorMessage);
                        alert.addClass('m-form-error');
                        alertMessage.addClass("field-validation-error");
                        $('#NoReason').trigger("focus");
                    }
                },
                error: function (xhr, status, thrownError) {
                    console.log("Form submission failed: " + thrownError);
                }
            });
        }

        // Recaptcha failure logic
        function recaptchaFailure() {
            $('div.form-input-block').hide();
            alert.addClass('m-form-error');
            alertMessage.addClass("field-validation-error");
            alertMessage.append(
                'Sorry, there is a problem with this form. Try again later. <a href="/contact-us">Contact us</a> if you need to speak to someone.'
            );
        }

    });

    var resetForm = function () {
        $('.m-form-optional').hide();
        $('.m-form-optional-improve').hide();

        theForm.find("select").each(function () {
            $(this).prop('selectedIndex', 0);
        });

        theForm.find("textarea").each(function () {
            $(this).val('');
        });

        $('.m-form-option-label input[type=radio]', theForm).first().prop('checked', true);
    };
}
